import React from "react";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  statusBar: {
    fontSize: theme.textFontSize,
    margin: "10px",
    lineHeight: "17px",
    color: theme.TextColor
  },
  clickable: {
    cursor: "pointer",
    "&:hover": {
      color: theme.HeaderSelectedText
    }
  },
  activeFilter: {
    color: theme.HeaderSelectedText,
    fontWeight: 'bold'
  }
});

class StatusBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    };
  }

  getFilteredData = (filterCondition, index) => {
    this.props.filterGridData && this.props.filterGridData(filterCondition);
    this.setState({
      activeIndex: index
    });
  };

  render() {
    const { classes, data, customClass } = this.props;
    const dataLength = data.length;
    return (
      <div className={`${classes.statusBar} ${customClass? customClass : ""}`}>
        {dataLength > 1 ? (
          data.map((data, index) => {
            return (
              <span key={index}>
                <span
                  onClick={() => {
                    if (this.state.activeIndex !== index) {
                      this.getFilteredData(data.filterCondition, index);
                    } else {
                      this.getFilteredData();
                    }
                  }}
                  className={`${classes.clickable} ${
                    this.state.activeIndex === index ? classes.activeFilter : ""
                  }`}
                >
                  {data.label}
                </span>
                <span>{index < dataLength - 1 ? " | " : ""}</span>
              </span>
            );
          })
        ) : (
          <span className={`${classes.clickable} ${classes.activeFilter}`}> {data[0].label} </span>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(StatusBar);
